<template v-if="this.$store.getters.GetBlock.preloader"> 
    <div v-if="!this.$store.getters.Loaded"  class="uk-container-xsmall uk-position-center uk-overlay uk-overlay-default uk-animation-fade uk-position-z-index-one" id="load" style="min-height: 1000px;min-width: 1000px;"> 
        <h2 v-if="this.$store.getters.Errors.activ" class="uk-position-center uk-overlay uk-overlay-default uk-animation-fade uk-position-z-index uk-text-center">{{this.$store.getters.Errors.code}}<p>{{this.$store.getters.Errors[this.$store.getters.Lang]}}</p></h2>
        <h2  class="uk-position-center uk-overlay uk-animation-fade uk-position-z-index-one uk-text-center">Load...</h2>
    </div>
    <!--img v-if="!this.$store.getters.Loaded" class="uk-position-center uk-overlay uk-overlay-default uk-animation-fade" alt="Load..." src="../assets/img/res/loader6.gif"-->  
    <!--img v-if="!this.$store.getters.Preloaded" class="uk-position-center uk-overlay uk-overlay-default" alt="Load..." src="../assets/img/res/loader6.gif"-->  
    
</template>
<script>


var setVanta = ()=>{
if (window.VANTA) window.VANTA.TRUNK({
  el: "#load",
  mouseControls: false,
  touchControls: false,
  gyroControls: false,
  minHeight: 50.00,
  height:200.00,
  minWidth: 50.00,
  width: 200.00,
  scale: 0.50,
  scaleMobile: 0.10,
  color: 0x07476d,
  backgroundColor: '#FFFFFF00',
  backgroundAlpha: 100,
  chaos: 3
})
}


export default {
  mounted() {
      if (!this.$store.getters.Loaded){
        this.loadtrunk()
      }
      
  },
  updated(){
    //this.loadtrunk()
  },
  unmounted(){
    
  },
  methods:{
    loadtrunk(){
        setVanta()
        //window.edit_page.Event.subscribe( "Page.beforeNewOneFadeIn", setVanta )
    }
  }
}




</script>
